import {Component, Input} from '@angular/core';
import {ConsignorContactComponent} from '../consignor-contact/consignor-contact.component';
import { MatDialog } from '@angular/material/dialog';
import {ItemSummaryItemService} from '../../shared/asset/item-summary-item.service';

@Component({
  selector: 'lib-item-summary-contact-seller-link',
  templateUrl: './contact-seller-link.component.html'
})
export class ContactSellerLinkComponent {

  @Input() itemId: number;
  @Input() itemService: ItemSummaryItemService;

  constructor(private dialog: MatDialog) {
  }

  public showContactInfo() {
    const dialogRef = this.dialog.open(ConsignorContactComponent, {
      panelClass: 'mat-panel--full-height',
      data: {
        itemId: this.itemId,
        itemService: this.itemService
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      /* if (result === 'sendReminder') {
         this.titleReminderEmailComponent.openSellerReminderDialog();
       }*/
    });
  }
}
